import { Stack, TextField } from '@mui/material';
import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { ARIA_LABEL } from '@/constants/ariaLabel';
import { API_METHOD } from '@/service/constants';
import { COMMON_STRING } from '@/constants/dictionary';
import { MTDialog } from '../common/MTDialog';
import { SemiBoldTypography } from '../common/Semiboldtypography';
import { EvaluationCommentField } from '../ActionEvaluationDialog/common/EvaluationCommentField';
import { TEXT_FIELD_CONSTANCE } from '../ActionEvaluationDialog/constants';
import { EvaluationSourceButtonsSet } from './EvaluationSourceButtons';

interface EvaluationDialogProps {
  onClose: VoidFunction;
  openDialog: boolean;
  onSubmit: (
    action: API_METHOD.POST | API_METHOD.PUT | API_METHOD.DELETE,
  ) => Promise<void>;
  currentSource: { link: string; comment: string };
  setCurrentSource: Dispatch<SetStateAction<{ link: string; comment: string }>>;
  isEditMode: boolean;
  isSubmitDisabled: boolean;
}

export const EvaluationSourceDialog = ({
  onClose,
  openDialog,
  onSubmit,
  currentSource,
  setCurrentSource,
  isEditMode,
  isSubmitDisabled,
}: EvaluationDialogProps) => {
  return (
    <MTDialog
      aria-label={ARIA_LABEL.EVALUATION_SOURCES_DIALOG}
      open={openDialog}
      onClose={onClose}
      title={
        isEditMode
          ? COMMON_STRING.UPDATE_EVALUATION_SOURCE
          : COMMON_STRING.ADD_EVALUATION_SOURCE
      }
      maxWidth='xs'
      fullWidth
    >
      <Stack width='100%' gap={1}>
        <SemiBoldTypography>{COMMON_STRING.ADD_LINK}</SemiBoldTypography>

        <TextField
          value={currentSource.link}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            setCurrentSource((prev) => ({ ...prev, link: event.target.value }))
          }
          placeholder={TEXT_FIELD_CONSTANCE.PLACEHOLDER_LINK}
        />

        <SemiBoldTypography>{COMMON_STRING.COMMENT}</SemiBoldTypography>
        <EvaluationCommentField
          placeholder={TEXT_FIELD_CONSTANCE.PLACEHOLDER_COMMENT}
          addComment={(value: string) =>
            setCurrentSource((prev) => ({ ...prev, comment: value }))
          }
          comment={currentSource.comment}
        />
        <EvaluationSourceButtonsSet
          isEditMode={isEditMode}
          isSubmitDisabled={isSubmitDisabled}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      </Stack>
    </MTDialog>
  );
};
